import React from "react";
import styled from "styled-components";
import {
  FaGithub,
  FaHeart,
  FaLinkedinIn,
  FaTwitter
} from "react-icons/fa";
import { motion } from "framer-motion";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <StyledFooter>
      <div className="footer-content">
        <motion.div 
          className="footer-divider"
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        />
        
        <div className="footer-bottom">
          <div className="footer-copyright">
            © {currentYear} Shoumik Kumbhakar
          </div>
          
          <div className="footer-made-with">
            <span>Made with</span>
            <motion.div
              animate={{ 
                scale: [1, 1.2, 1],
              }}
              transition={{
                duration: 1,
                repeat: Infinity,
                repeatType: "loop",
              }}
            >
              <FaHeart className="heart-icon" />
            </motion.div>
            <span>using React</span>
          </div>
          
          <div className="footer-social">
            <a href="https://github.com/mixmaker" target="_blank" rel="noreferrer" aria-label="GitHub">
              <FaGithub />
            </a>
            <a href="https://www.linkedin.com/in/shoumik-kumbhakar-06a195225" target="_blank" rel="noreferrer" aria-label="LinkedIn">
              <FaLinkedinIn />
            </a>
            <a href="https://twitter.com/almost_shoumik" target="_blank" rel="noreferrer" aria-label="Twitter">
              <FaTwitter />
            </a>
          </div>
        </div>
      </div>
    </StyledFooter>
  );
};

const StyledFooter = styled.footer`
  position: relative;
  width: 100%;
  padding: 1.5rem 0;
  background-color: transparent;
  
  .footer-content {
    width: 90%;
    max-width: 1200px;
    margin: 0 auto;
  }
  
  .footer-divider {
    height: 1px;
    background-color: var(--border-color);
    opacity: 0.3;
    margin: 0 auto 1.5rem;
    transform-origin: center;
    width: 30%;
  }
  
  .footer-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 1rem;
    
    .footer-copyright {
      font-size: 0.9rem;
      color: var(--secondary-text);
      letter-spacing: 0.05em;
      font-weight: 400;
    }
    
    .footer-made-with {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      font-size: 0.9rem;
      color: var(--secondary-text);
      letter-spacing: 0.05em;
      font-weight: 400;
      
      .heart-icon {
        color: #ff6b6b;
        font-size: 1rem;
      }
    }
    
    .footer-social {
      display: flex;
      gap: 1.25rem;
      
      a {
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--secondary-text);
        transition: all 0.3s ease;
        
        svg {
          font-size: 1.1rem;
        }
        
        &:hover {
          color: var(--vibrant);
          transform: translateY(-3px);
        }
      }
    }
  }
  
  @media only screen and (max-width: 768px) {
    .footer-bottom {
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 1rem;
      
      .footer-social {
        order: -1;
        margin-bottom: 0.5rem;
      }
    }
  }
`;

export default Footer;
